module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-non-bodymatter element-type-introduction element-with-heading",
    attrs: {
      "id": "introduction"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "introduction-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('h1', {
    staticClass: "number-and-title"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Introduction")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "introduction-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("Facts are subject to change. Truth is eternal. I want you to shake off any doubts, fears, or past experiences that cut down negatively on you as a person. Your past has no future, and those facts are about to change. It doesn’t matter what the past says about you. It matters what God says about you—He has called you for greatness.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("God has called you to do mighty things for Him, but are you prepared to "), _c('b', [_vm._v("maximize your calling")]), _vm._v("? Your body is the vessel by which you preach the gospel and live out your abundant life. This vessel needs to be healthy! Working out enables you to reach out. It allows you to maintain a state of physical fitness and health that is readily prepared to accomplish the will of the Father.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Shift the focus of fitness from being just about you to what Christ has called you to finish. "), _c('b', [_vm._v("When you center your fitness on Christ")]), _vm._v(", your motivation, energy, purpose, and results will speedily skyrocket to a whole new level!")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("There are many reasons why you may have picked up this book. Maybe you want to know how fitness relates to your life as a Christian. Or maybe you want to know what God’s Word says about getting in shape instead of what society blabs to you. Perhaps you aren’t a Christian and are curious about this book’s viewpoint on fitness. Are you stuck in a cycle of obesity, having tried many ways to break the cycle, but nothing has worked?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Regardless of why you picked up this book, prepare to learn why taking care of your body is essential to God and how to accomplish that. If you are trapped in obesity, worry, obsessing about your body image, or feeling inadequate, get ready to be set free. Jesus has already performed everything necessary for you to have victory in EVERY area of your life.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34b75ea0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/introduction.vue
// module id = 75
// module chunks = 0